__turbopack_context__.v({
  "className": "HeQ5yG_className",
  "variable": "HeQ5yG_variable",
});
